import { render } from "./Pago_categoriaList.vue?vue&type=template&id=737c5c88"
import script from "./Pago_categoriaList.vue?vue&type=script&lang=js"
export * from "./Pago_categoriaList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__